import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';

// i18n
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          // عمومی
          "shop": "Shop",
          "cart": "Cart",
          "login": "Login",
          "register": "Register",
          "logout": "Logout",
          "admin": "Admin Panel",
          "blog": "Blog",
          "back": "Back",

          // محصولات
          "addToCart": "Add to Cart",
          "price": "Price",
          "inStock": "In Stock",
          "outOfStock": "Out of Stock",
          "productDetails": "Product Details",

          // سبد خرید
          "total": "Total",
          "checkout": "Checkout",
          "remove": "Remove",
          "emptyCart": "Your cart is empty",

          // احراز هویت
          "email": "Email",
          "password": "Password",
          "confirmPassword": "Confirm Password",
          "forgotPassword": "Forgot Password?",
          "resetPassword": "Reset Password",
          "rememberMe": "Remember Me",

          // بلاگ
          "readMore": "Read More",
          "relatedPosts": "Related Posts",
          "comments": "Comments"
        }
      },
      fa: {
        translation: {
          // عمومی
          "shop": "فروشگاه",
          "cart": "سبد خرید",
          "login": "ورود",
          "register": "ثبت نام",
          "logout": "خروج",
          "admin": "پنل ادمین",
          "blog": "وبلاگ",
          "back": "بازگشت",

          // محصولات
          "addToCart": "افزودن به سبد خرید",
          "price": "قیمت",
          "inStock": "موجود",
          "outOfStock": "ناموجود",
          "productDetails": "جزئیات محصول",

          // سبد خرید
          "total": "مجموع",
          "checkout": "تسویه حساب",
          "remove": "حذف",
          "emptyCart": "سبد خرید شما خالی است",

          // احراز هویت
          "email": "ایمیل",
          "password": "رمز عبور",
          "confirmPassword": "تکرار رمز عبور",
          "forgotPassword": "رمز عبور را فراموش کرده‌اید؟",
          "resetPassword": "بازنشانی رمز عبور",
          "rememberMe": "مرا به خاطر بسپار",

          // بلاگ
          "readMore": "ادامه مطلب",
          "relatedPosts": "مطالب مرتبط",
          "comments": "نظرات"
        }
      }
    },
    // fallbackLng: 'en',

    lng: 'fa',
    fallbackLng: 'fa',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;